<template>
    <div class="right-view" ref="rightView" v-bind:class="{'margin-right-10': rule.ruleId}">
        <div v-if="rule !== null" class="po-subtitle">
            <div class="policy-item">
                <div class="category-labels">
                    <span v-for="(ctg, idx) of rule.ctgLabel" class="icon-tag" data-type="category-label" :key="idx">{{getCategoryLabel(ctg)}}</span>
                    <!--<button type="button" class="buttons-icon" data-type="ghost" data-size="xs" data-icon="more" data-tooltip-content="#tooltip-category-label" data-trigger="tooltip-tbl">more</button>-->

                    <!-- 카테고리 라벨 툴팁 -->
                    <div class="tooltip_templates">
                        <div id="tooltip-category-label">
                            <ul class="list-default">
                                <li v-for="(ctg, idx) of rule.ctgLabel" :key="idx">{{getCategoryLabel(ctg)}}</li>
                            </ul>
                        </div>
                    </div>
                </div>
                <div class="position-inherit">
                    <h2 class="name">
                        {{rule.siteCd == constants.POLICY_TYPE.BEST_PRACTICE ? rule[$i18n.locale+'RuleTitle'] : rule.titl}}{{rule.ruleTitl}}
                    </h2>
                </div>
            </div>

            <div class="actions">
                <button v-if="(policy.userDefiYn == constants.PARAM.SELECT.Y) && (getMenuAuth == constants.AUTH_TYPE.EDIT)" type="button" class="buttons-icon" data-type="line" data-icon="more" data-tooltip-content="#tooltip-actions03" data-trigger="management">{{$t('LABEL.MANAGE')}}</button>
                <span class="seperate">
                    <button type="button" class="buttons-icon" data-type="ghost" data-icon="close" data-trigger="close" v-on:click="callHideDetail">{{$t('LABEL.CLOSE')}}</button>
                </span>


                <!-- 관리 버튼 툴팁 메뉴 -->
                <div v-if="getMenuAuth === constants.AUTH_TYPE.EDIT" class="tooltip_templates">
                    <div id="tooltip-actions03">
                        <ul class="list-actions">
                            <li>
                                <button type="button" class="btn" data-trigger="" v-on:click="callOpenPopup(rule,constants.FORM_TYPE.EDIT)">{{ $t('COMMON.BUTTON.CAMEL.EDIT')}}<!--수정--></button>
                            </li>
                            <li>
                                <button type="button" class="btn" data-trigger="" v-on:click="callOpenPopup(rule,constants.FORM_TYPE.COPY)">{{ $t('COMMON.BUTTON.CAMEL.COPY')}}<!--복사--></button>
                            </li>
                            <li>
                                <button type="button" class="btn" data-trigger="" v-on:click="callDeleteRule([rule])">{{ $t('COMMON.BUTTON.CAMEL.DELETE')}}<!--삭제--></button>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>

        <div class="wing-contents">
            <side-rule-detail-info  v-if="rule.ruleId" v-bind:rule="rule" v-bind:action-template-list="actionTemplateList" v-bind:user-list="userList" :roleCode="roleCode" parents-type="plcy"></side-rule-detail-info>
        </div>
    </div>
</template>

<script>

    import SideRuleDetailInfo from '../rule/SideRuleDetailInfo.vue'

    export default {
        name: 'policySideRuleDetail',
        props: {
            policy: Object,             // Rule들이 속해있는 Policy 정보
            rule: Object,               // Detail 정보에서 열려있는 Rule 정보
            categoryList: Array,        // 회사에 등록되어있는 Category Label 정보 리스트
            actionTemplateList: Array,  // action 정보 리스트
            userList: Array,            // 회사에 가입되어있는 사용자 리스트 정보(Email 수신자 추가시 필요)
            callDeleteRule: Function,
            callHideDetail: Function,
            callOpenPopup: Function,
            roleCode: {
                type: String,
                default: ''
            }
        },
        data: function() {
            return {
                initOptions: false
            }
        },
        components: {
            'side-rule-detail-info' : SideRuleDetailInfo
        },
        computed: {
            getMenuAuth: function(){
                //메뉴 별 권한
                let auth = _.find(this.$store.state.GOV_MENU_AUTH, {menuId: this.constants.MENU.POLICY})
                return auth.authTypeCd
            }
        },
        watch: {
            rule: function(){
                !this.initOptions ? this.setManagementOptions() : false
            }
        },
        methods: {
            getCategoryLabel(ctgId) {
                var categoryLabel = '';
                if(this.categoryList != null) {
                    for (var category of this.categoryList) {
                        if (category.ctgId === ctgId) {
                            categoryLabel = category.ctgLabel;
                        }
                    }
                }
                return categoryLabel;
            },
            setManagementOptions: function() {
                var $moreActions = $('[data-tooltip-content="#tooltip-actions03"]');
                $moreActions.tooltipster({
                    animation: 'fade',
                    side: 'bottom',
                    theme: 'go-actions',
                    interactive: true,
                    trigger: 'click',
                    arrow: false,
                    functionBefore: function(instance, helper) {
                        $(helper.origin).addClass("selected");
                    },
                    functionAfter: function(instance, helper) {
                        $(helper.origin).removeClass("selected");
                    },
                    functionPosition: function(instance, helper, position) {
                        position.coord.top -= 7;
                        position.coord.left = helper.geo.origin.offset.right - position.size.width;
                        return position;
                    }
                });

                this.initOptions = true
            }
        },
        destroyed: function() {
            $('body').removeAttr('data-wing-expand');
        },
        updated: function() {
            let _this = this;
            setTimeout(function(){
                let minHeight = _this.$refs.rightView.clientHeight + "px";
                let element = document.getElementsByClassName("layout-contents")[0];
                if (element) {
                    element.style.minHeight = minHeight;
                }    
            }, 200);
        },
    }
</script>
<style scoped>
.position-inherit .name{
    position: inherit !important;
}
.margin-right-10 {
    margin-right: 10px !important;
}
</style>


// WEBPACK FOOTER //
// src/components/policy/policySideRuleDetail.vue